import { Auth, Hub } from "aws-amplify";
import router from "@/router";
import store from "@/state/store";

export function authentication() {
  const user = JSON.parse(localStorage.getItem("userData"))
  
  Hub.listen("auth", async ({ payload: { event, data } }) => {
    console.log(data);
    console.log(event);
    switch (event) {
      case "signIn":
        console.log("data.signInUserSession.idToken.payload: ", data.signInUserSession.idToken.payload);
        var userDetails = {
          cognitoSub: data.signInUserSession.idToken.payload.sub,
          userName: data.username,
          name: data.signInUserSession.idToken.payload.name,
          email: data.signInUserSession.idToken.payload.email,
          mobile: data.signInUserSession.idToken.payload['custom:mobile_number'],
          jwtToken: data.signInUserSession.idToken.jwtToken,
          refreshToken: data.signInUserSession.refreshToken.token,
          expirationTime: data.signInUserSession.idToken.payload.exp
        };
        
        store.commit('auth/SET_CURRENT_USER', userDetails);
        await store.dispatch('user/getUserAccess')
        console.log('GOTO HOME');
        router.push({ name: 'home' });
        break;
      case "signOut":
        store.commit('auth/CLEAR_CURRENT_USER');
        router.push({ name: 'login' });
        break;
    }
  });

  if (user) {
    const time = Date.now()
    let timenow = Math.floor(time / 1000);
    
    if (user.expirationTime - timenow > 0) {
      Auth.currentAuthenticatedUser()
        .then(async (user) => {
          console.log(user);
          let currentSession = user.signInUserSession
          user.refreshSession(currentSession.refreshToken, async (err, session) => {
            if (err) {
              Auth.signOut()
                .then(() => {
                  store.commit('auth/CLEAR_CURRENT_USER');
                  router.go()
                }).catch(err => console.log("Error refreshing tokens: " + err));
            } else {
              let userData = JSON.parse(localStorage.getItem('userData'))
              let tmp_userData = {
                ...userData,
                jwtToken: session.idToken.jwtToken
              }
              store.commit('auth/SET_CURRENT_USER', tmp_userData);
              await store.dispatch('user/getUserAccess')
            }
          })
        })
        .catch(err => console.log("Auth.currentAuthenticatedUser(): " + err));
    } else {
      Auth.signOut()
        .then(() => {
          console.log("SignOut")
          store.commit('auth/CLEAR_CURRENT_USER');
          router.go()
        }).catch(err => console.log("Error refreshing tokens: " + err));
    }
  }
}